import { proctoringOptionProfile } from "../proctoring-profile/schema-validators";
import SchemaValidator from "../schema-validator";
import { TSchema, Type } from "@sinclair/typebox";

function OptionalOrNull<T extends TSchema>(type: T) {
	return Type.Optional(Type.Union([Type.Null(), type]));
}

const proctoringAssessmentConfigurationType = Type.Object({
	enabled: Type.Boolean(),
	isLiveProctored: Type.Boolean(),
	isLivePopIn: Type.Boolean(),
	enablePostReview: Type.Boolean(),
	password: Type.Union([Type.Null(), Type.String()]),
	thirdPartyAssessmentOption: OptionalOrNull(
		Type.Object({
			thirdPartyUrl: OptionalOrNull(Type.String()),
			password: OptionalOrNull(Type.String()),
			thirdPartyPlatformId: OptionalOrNull(Type.Number()),
		}),
	),
	proctoringOptionProfile: proctoringOptionProfile,
});

const proctoringAssessmentConfigurationV2 = new SchemaValidator(proctoringAssessmentConfigurationType);

const proctoringAssessmentConfigurationV2OrNull = new SchemaValidator(
	Type.Union([Type.Null(), proctoringAssessmentConfigurationType]),
);

const proctoringAssessmentConfigurationResponse = new SchemaValidator(
	Type.Object({
		standaloneStudentInfo: OptionalOrNull(
			Type.Array(
				Type.Object({
					id: Type.Number(),
					userId: Type.Number(),
					email: Type.String(),
					firstName: Type.String(),
					lastName: Type.String(),
				}),
			),
		),
	}),
);

const enabledOptionsResponse = new SchemaValidator(
	Type.Object({
		proctoringMethod: Type.Array(
			Type.Union([
				Type.Literal("automated"),
				Type.Literal("live"),
				Type.Literal("pop-in"),
				Type.Literal("pop-in-post-review"),
			]),
		),
	}),
);

export default {
	proctoringAssessmentConfigurationV2,
	proctoringAssessmentConfigurationV2OrNull,
	proctoringAssessmentConfigurationResponse,
	enabledOptionsResponse,
};
